module.exports = __webpack_public_path__ + "img/warning-red.ee01caf.svg";